import axios from "axios";
import {AiChatbotStarterDto} from "../models/AiChatbotStarterDto";
import {OfferType} from "../models/OfferPageDto";

const HTTP_NOT_FOUND = 404;

interface AiChatbotStarterResponse {
    readonly starter: AiChatbotStarterDto;
}

export type AiChatbotStarterResult =
    | { readonly status: "FOUND", readonly starter: AiChatbotStarterDto }
    | { readonly status: "NOT_FOUND" }
    | { readonly status: "ERROR" };

export class AiChatbotStarterService {
    // Le starter est optionnel : aucune erreur n'est propagée, le résultat est typé
    static async getAiChatbotStarter(offerType: OfferType): Promise<AiChatbotStarterResult> {
        return axios
            .get<AiChatbotStarterResponse>(`/api/showcase/${offerType.toLowerCase()}/ai-chatbot-starter`)
            .then((response): AiChatbotStarterResult => ({status: "FOUND", starter: response.data.starter}))
            .catch((error): AiChatbotStarterResult => {
                if (axios.isAxiosError(error) && error.response?.status === HTTP_NOT_FOUND) {
                    return {status: "NOT_FOUND"};
                }
                console.warn("AI Chatbot Starter : chargement impossible", error);
                return {status: "ERROR"};
            });
    }
}
